let _ = t => t,
    _t;

import { CANDY_APPLE_LIGHT, GYPSUM, OBSIDIAN, OLAF } from 'HubStyleTokens/colors';
import { createGlobalStyle } from 'styled-components';
export const GlobalStyle = createGlobalStyle(_t || (_t = _`
  html {
    min-height: 100%;
  }
  body {
    min-height: 100% !important;
    font-size: 17px !important;
    background-color: ${0};

    small {
      font-size: 14px !important;
    }
  }

  .grecaptcha-badge {
    visibility: hidden;
  }

  .hsg-notice {
    padding: 20px;
    background-color: ${0};
    opacity: 0.83;
    margin-bottom: 15px;
    text-align: center;
  }

  body:not([class*="cookie-banner-"]) {
    #hs-eu-cookie-confirmation {
      display: none !important;
    }
  }

  .cookie-banner-top-static {
    padding-top: 0.1px;
    #hs-eu-cookie-confirmation {
      position: static !important;
      z-index: 10;
      width: 100% !important;
    }
  }

  .cookie-banner-hidden {
    #hs-eu-cookie-confirmation {
      display: none !important;
    }
  }

  #hs-eu-cookie-confirmation {
    background: #2d3e50 !important;
    box-shadow: none !important;
    border: none !important;
    width: auto !important;

    #hs-eu-cookie-confirmation-inner {
      box-sizing: content-box !important;
      margin: 0 auto !important;
      max-width: 1080px !important;
      padding: 1.25rem 2rem !important;

      #hs-en-cookie-confirmation-buttons-area {
        #hs-eu-confirmation-button {
          font-family: 'AvenirNext', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
          background-color: ${0} !important;
          border: 0 !important;
          border-radius: 0.1875rem !important;
          box-shadow: none !important;
          color: ${0} !important;
          display: inline-block !important;
          line-height: 1.25 !important;
          padding: 0.75rem 1.5rem !important;
          text-shadow: none !important;
          transition: 0.15s color ease-out, 0.15s background-color ease-out, 0.15s border-color ease-out !important;

          &:hover {
            background-color: rgba(${0}, 0.9) !important;
          }

          &:active {
            background-color: ${0} !important;
          }
        }
        #hs-eu-decline-button {
          font-family: 'AvenirNext', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
          border: 0 !important;
          background-color: ${0} !important;
          border-radius: 0.1875rem !important;
          box-shadow: none !important;
          color: ${0} !important;
          display: inline-block !important;
          line-height: 1.25 !important;
          padding: 0.75rem 1.5rem !important;
          text-shadow: none !important;
          transition: 0.15s color ease-out, 0.15s border-color ease-out !important;

          &:active {
            border-color: ${0} !important;
          }
        }
      }
    }
  }
`), OLAF, CANDY_APPLE_LIGHT, OLAF, OBSIDIAN, OLAF, GYPSUM, OLAF, OBSIDIAN, GYPSUM);